import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export const RemoveMemberDialog = ({ open, member, onClose, onConfirm, loading }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Poista jäsen</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Haluatko varmasti poistaa jäsenen{' '}
        <strong>
          {member?.name || member?.email || member?.phone || 'nimetön jäsen'}
        </strong>{' '}
        organisaatiosta? Tätä toimintoa ei voi perua.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Peruuta</Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading} autoFocus>
        Poista jäsen
      </Button>
    </DialogActions>
  </Dialog>
);
